import styled from "styled-components";

const AlarmModal = () => {
  const alarms = [];
  return (
    <AlarmModalWrapper>
      <div className="scroll_box">
        {alarms.length === 0 ? (
          <div className="center" style={{ width: "100%", height: "100%" }}>
            <p style={{ fontSize: "14px" }}>도착한 알림이 없습니다.</p>
          </div>
        ) : (
          alarms.map((alarm, index) => (
            <AlarmData
              isFirst={index === 0}
              title={alarm.title}
              content={alarm.content}
              time={alarm.time}
              isChecked={alarm.isChecked}
            />
          ))
        )}
      </div>
    </AlarmModalWrapper>
  );
};

const AlarmData = ({ isFirst, title, content, time, isChecked }) => {
  return (
    <div
      className="alarmData"
      style={isFirst ? { marginTop: "0px" } : { marginTop: "8px" }}
    >
      <div style={{ display: "flex", alignItems: "center", height: "20px" }}>
        <p style={{ color: "#1167ed", fontSize: "14px" }}>{title}</p>
        {!isChecked && <div className="redcircle" />}
      </div>
      <p style={{ color: "#222222", marginTop: "6px" }}>{content}</p>
      <p style={{ color: "#6d6d6d", marginTop: "6px" }}>{time}</p>
    </div>
  );
};

const AlarmModalWrapper = styled.div`
  width: auto;
  height: auto;
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0 0 20px 0 #e6e6e6;
  padding: 12px;
  z-index: 1;
  .scroll_box {
    width: 339px;
    height: 472px;
    overflow-y: scroll;
    overflow-x: hidden;
    &::-webkit-scrollbar {
      width: 4px;
      z-index: 1;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #d9d9d9;
      border-radius: 20px;
    }
  }
  .alarmData {
    width: 331px;
    height: 88px;
    border-radius: 8px;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 8px;
    &:hover {
      background-color: #f5f5f5;
      cursor: pointer;
    }
    > p {
      width: 323px;
      margin: 0;
      font-family: "notoSans";
      font-size: 14px;
    }
  }
  .redcircle {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #f25c5c;
    margin-top: -15px;
    margin-left: 2px;
  }
`;

export default AlarmModal;
